var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultRadio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18098_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9722 12.0032C23.9713 18.6434 18.6188 23.9753 11.9562 23.9728C5.34301 23.9702 0.00875284 18.6072 0.0136753 11.9658C0.0186701 5.33134 5.37899 0.00779565 12.0478 0.0141659C18.64 0.0205361 23.9731 5.38252 23.9722 12.0032ZM5.64827 12.0422C8.34259 13.6351 10.316 15.9134 12.0904 18.4119C13.5714 15.6308 15.9708 13.8172 18.4181 12.0283C15.6777 10.478 13.7731 8.14857 12.0217 5.62314C10.2499 8.12106 8.37046 10.4626 5.64827 12.0422Z",
    fill: "#5F30E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18098_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultRadio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/defaultRadio.40c35ab71b22397739296ec593acd936.svg";